import { render, staticRenderFns } from "./InDesignEditor.vue?vue&type=template&id=338b2af0&scoped=true"
import script from "./InDesignEditor.vue?vue&type=script&lang=js"
export * from "./InDesignEditor.vue?vue&type=script&lang=js"
import style0 from "./InDesignEditor.vue?vue&type=style&index=0&id=338b2af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338b2af0",
  null
  
)

export default component.exports